export function getFlatpickrDefaults(): any {
  const dateStr = typeof localStorage !== 'undefined'
    ? (localStorage.getItem('live_date')) : null;
  let minDate: Date | undefined;
  if (dateStr) {
    let clean = String(dateStr).trim();
    if (clean && clean !== 'null' && clean !== 'undefined' && clean !== 'NaN') {
      if ((clean.startsWith('"') && clean.endsWith('"')) || (clean.startsWith("'") && clean.endsWith("'"))) {
        clean = clean.slice(1, -1).trim();
      }
      if (/^\d{4}-\d{2}-\d{2}$/.test(clean)) {
        const [y, m, d] = clean.split('-').map(Number);
        const dt = new Date(y, m - 1, d, 0, 0, 0, 0);
        if (!isNaN(dt.getTime())) {
          minDate = dt;
        }
      } else if (!isNaN(Date.parse(clean))) {
        const dt = new Date(clean);
        if (!isNaN(dt.getTime())) {
          minDate = dt;
        }
      }
    }
  }
  return {
    minDate
  };
}
